module.exports = __webpack_public_path__ + "static/media/CompoundRecipes.a2d7e1a1.jpg";